import React, { useEffect } from "react";
import orderIcon from "../.././../assets/orderIcon.png";

import order_confirm from "../../assets/lottie/order_confirm.json";
import Lottie, { useLottie } from "lottie-react";
import { useCheckoutContext } from "../../context/checkout/CheckoutContext";
import { useShoppingCart } from "../../context/CartContext.tsx/ShoppingCartContext";
import payment_error from "../../assets/lottie/payment_error.json";
// import { Link, Navigate, useHistory } from 'react-router-dom';
import appBanner from "../../assets/App banner.png";

import dicountBanner from "../../assets/PraushBanner.png";

import playStore from "../../assets/Play_Store.avif";
import iosStore from "../../assets/ios_app.png";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "react-router-dom";
import { isAndroid, isIOS } from 'react-device-detect';





import {
  initPixel,
  trackPageView,
  trackPurchase,
} from "../../utils/FacebookPixel";
import { addPaymentInfoEvent, googlePurchase, googlePurchaseEvent, pushCartItem } from "../../utils/GoogleAnalytics";
import { trackCharged } from "../../utils/CleverTap";
import { noBackButton } from "../../utils/BrowserOperations";
import { trackProceedPay } from "../../utils/FacebookPixel";
import Slider from "./Slider";
import Aquatribe from "./Aquatribe";
import VideoSection from "./VideoSection";
import HoverRating from "./HoverRating";
import FollowUsOn from "./FollowUsOn";
import GuideCTA from "./GuideCTA";
import ProgressBar from "./ProgressBar";
import FeedbackSurvey from "./FeedbackSurvey";
import ScrollToBottomButton from "./ScrollToBottomButton";
import OrderDetails from "./OrderDetails";

import RectangleLens from "../../assets/RectangleLens.png";
import giftBox from "../../assets/giftBox.png";
import { shooglooAffiliate } from "../../utils/ShooglooAffiliate";


interface thankyouProps {
  lenskart_id?: string | any;
  delivery_date?: string | any;
  created_at?: string | any;
  status?: string | any;
}

const Thankyou = (props: thankyouProps) => {
  useEffect(() => {
    // Initialize Facebook Pixel
    noBackButton();

  }, []);




  const {
    orderStatus,
    createCart,
    setOrderStatusFunction,
    setRazorDataFunction,
    checkoutData,
  } = useCheckoutContext();

  const lenskart_order_id: any = orderStatus?.Status.lenskart_order_id;
  const shopify_order_id: any = orderStatus?.Status.id;
  const delivery_date = orderStatus?.Status.delivery_date;
  const created_at:any = orderStatus?.Status.created_at;
  const id = orderStatus?.Status.id;
  const status = orderStatus?.Status.status;
  const order_line_item = orderStatus?.Status.order_line_items;
  const itemsNumber = order_line_item?.length-1;
  const firstItem = order_line_item?.[0]?.variant_title;
  const firstItem2 = order_line_item?.[0]?.product_title;
  const itemImage = order_line_item?.[0]?.item_image;

  const customerName = orderStatus?.Status.shipping_address.first_name;
  const cashback = Number(orderStatus?.Status.cashback);

  const inputDate = new Date(delivery_date);
  const options:any = {  month: 'short',day: 'numeric', year: '2-digit' };
  const deliveryDate = inputDate.toLocaleString('en-US', options);

  const inputDate2 = new Date(created_at);
  const options2:any = { day: 'numeric', month: 'short', year: '2-digit' };
  const createdAt = inputDate2.toLocaleString('en-US', options2);

  const payment_id: any = orderStatus?.Status.payment_id;

  const amount: any = orderStatus?.Status.amount;
  const discount_code: any = orderStatus?.Status.discount_code;
  const order_line_items:any = orderStatus?.Status.order_line_items;
  const payment_mode: any = orderStatus?.Status.payment_mode;




  // const firstItem = order_line_item.length > 0 ? order_line_item[0].variant_title : '';
  const {
    pageData,
    setPageData,
    emptyCart,
    getCartData,
    openPopup,
    closePopup,
  } = useShoppingCart();

  const data = getCartData;
  const cartLenght = checkoutData?.data.cart?.length;
  const cart = checkoutData?.data.cart;
  const total: any = checkoutData?.data.total;
  const cartId: any = checkoutData?.data.cart_id;

  let contentData: any;
  let dataLayerData: any;
  let cleverTapData: any;


  let utmSource: any = "";
  let utmMedium: any = "";
  let utmCampaign: any = "";
  let utmTerm: any = "";
  let utmContent: any = "";

  utmSource = Cookies.get("utmSource");
  utmMedium = Cookies.get("utmMedium");
  utmCampaign = Cookies.get("utmCampaign");
  utmContent = Cookies.get("utmContent");
  utmTerm = Cookies.get("utmTerm");


  // var order_item_array:any = [];




  // // Identify any line item is prower follow-up case
  // for (var x in order_line_items) {
  
  //   if(order_line_items[x].product_type == "colorLens"){
  //     var item_list_id = "1";
  //     var item_list_name = "Color Product"
  //   }
  //   else if(order_line_items[x].product_type == "Solution")
  //   {
  //     var item_list_id = "4";
  //     var item_list_name = "Solution"
  //   }
  //   else if(order_line_items[x].product_type == "Medical")
  //   {
  //     var item_list_id = "2";
  //     var item_list_name = "Clear Product"
  //   }
  //   else if(order_line_items[x].product_type == "Accessories")
  //   {
  //     var item_list_id = "5";
  //     var item_list_name = "Accessories"
  //   }
  //   else if(order_line_items[x].product_type == "toric")
  //   {
  //     var item_list_id = "3";
  //     var item_list_name = "Toric"
  //   }
  //   else
  //   {
  //     var item_list_id = "6";
  //     var item_list_name = "Others";
  //   }
  //   order_item_array.push({
  //     item_id: order_line_items[x].sku,
  //     item_name: order_line_items[x].product_title,
  //     item_list_id: item_list_id,
  //     item_list_name: item_list_name,
  //     item_variant: order_line_items[x].variant_title,
  //     price: order_line_items[x].price,
  //     quantity:order_line_items[x].quantity
  //   });
  // }

  // console.log(order_item_array,1);

  const tempCartItems:any = data?.data[0]?.temp_cart_items;
  // let cart_item_array:any = [];
  let order_item_array:any = [];
  let cart_item_array:any = [];
  const cartItemsEvent = pushCartItem(tempCartItems, cart_item_array);

  let order_content = 'product'

  
        if (order_line_items && order_line_items.length > 0) {  
            for (var x in order_line_items) {
    
              let power_type = ''
              if(order_line_items[x]?.has_power == 1){
                power_type = 'power'
              }else{
                power_type = 'zero power'
              }

              if (tempCartItems[x]?.product_type == 'gold_member') {
                if (parseInt(x) === 0) { // Convert x to a number explicitly
                  order_content = 'membership';
                } else {
                  order_content += ' & membership';
                }
              }
    
              order_item_array.push({
                  item_name: order_line_items[x]?.product_title,
                  item_id: order_line_items[x]?.id,
                  index: x,
                  item_brand: 'Aqualens',
                  item_category: order_line_items[x]?.product_type,
                  item_category2: order_line_items[x]?.title,
                  item_category3: order_line_items[x]?.subtitle,
                  power_type: power_type,
                  sph_left_eye_power: order_line_items[x]?.prescription?.left?.sph,
                  sph_right_eye_power: order_line_items[x]?.prescription?.right?.sph,
                  left_eye_boxes: order_line_items[x]?.prescription?.left?.boxes,
                  right_eye_boxes: order_line_items[x]?.prescription?.right?.boxes,
                  additional_left_eye_power: order_line_items[x]?.prescription?.left?.ap,
                  additional_right_eye_power: order_line_items[x]?.prescription?.right?.ap,
                  cyl_left_eye_power: order_line_items[x].prescription?.left?.cyl,
                  cyl_right_eye_power: order_line_items[x].prescription?.right?.cyl,
                  axis_left_eye: order_line_items[x]?.prescription?.left?.axis,
                  axis_right_eye:order_line_items[x]?.prescription?.right?.axis,
                  item_list_id: order_line_items[x]?.temp_cart_id,
                  item_list_name:order_line_items[x]?.product_type,
                  item_variant: order_line_items[x]?.variant_title,
                  price: order_line_items[x]?.price,
                  quantity: order_line_items[x]?.quantity     
                });
            
          }
        }



  if (cart && cartLenght && cartLenght > 0) {
    contentData = cart.map((item) => {
      let data = {
        id: item.variant_id,
        quantity: item.quantity,
      };
      return data;
    });
  }

  if (cart && cartLenght && cartLenght > 0) {
    dataLayerData = cart.map((item) => {
      let variantTitle = item.product_title;
      if (item.variant_title != null) {
        variantTitle = item.variant_title;
      }
      let data = {
        id: item.variant_id,
        price: item.price,
        quantity: item.quantity,
        name: item.product_title,
        variant: `${variantTitle}`,
      };
      return data;
    });
  }

  if (cart && cartLenght && cartLenght > 0) {
    cleverTapData = cart.map((item) => {
      let categoryT = item.product_type;
      let todayDate = new Date().toJSON().slice(0, 10);
      if (item.product_type == "gold_member") {
        window.clevertap.event.push("Gold Member");
      }
      let data = {
        productid: item.product_id,
        producttitle: item.product_title,
        amount: item.price,
        category: categoryT,
        date: todayDate,
        variantId: item.id,
      };
      return data;
    });
  }

  //Creating object for gtag integration

  // useEffect(() => {
  //   if (getCheckoutError && getCheckoutError !== 'success') {
  //     setIsClose(true);
  //   } else {
  //     setIsClose(false);
  //   }
  // }, [getCheckoutError]);

  setPageData(3);

  const navigate = useNavigate();

  const cart_id = data?.data[0].id;

  // console.log(lenskart_order_id);

  function clearCookies() {
    var cookies = ["utmCampaign", "utmMedium", "utmSource", "utmContent", "utmTerm"];

    cookies.forEach(function (cookieName) {
      document.cookie =
        cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    });
  }

  useEffect(() => {
    if (lenskart_order_id && lenskart_order_id !== "") {
    // console.log(order_item_array,2);
      // console.log(lenskart_order_id);
      initPixel();
      trackPageView();
      trackPurchase(total, "INR", "product", contentData);
      googlePurchase(total, cartId, dataLayerData);
      trackCharged(cleverTapData);
      addPaymentInfoEvent(payment_mode,cartItemsEvent);
      googlePurchaseEvent(amount, payment_id,payment_mode,discount_code, cartItemsEvent,order_content);
      shooglooAffiliate(amount,lenskart_order_id,utmSource);
      clearCookies();
      emptyCart(cart_id);
    }
  }, [lenskart_order_id]);

  

  const paylod: any = {
    temp_cart_id: cart_id,
    utm_source: utmSource,
    utm_campaign: utmMedium,
    utm_medium: utmCampaign,
    utm_term:utmTerm,
    utm_content:utmContent,
    order_source: "website",
    solution_delivery: true,
  };

  const handleClickCheckout = () => {
    openPopup("checkout");
  };
  //   if (lenskart_order_id && lenskart_order_id !== "") {
  //     console.log(lenskart_order_id);
  //     clearCookies();
  //     emptyCart(15);
  //   }

  //  const history = useHistory();
  function retryOrder() {
    // Redirect to the previous URL
    // window.history.back();
    setOrderStatusFunction();
    setRazorDataFunction();
    setPageData(1);
    navigate("/");
    closePopup();

    // createCart(paylod);
    // handleClickCheckout();
  }

  // var userAgent:any;
  
  // useEffect(() => {
  //  userAgent = navigator.userAgent;

  // }, []);


  // Get the user agent string
  // var userAgent = navigator.userAgent;
  // let iPhone = false;

  // // Check for Android
  // if (userAgent.match(/Android/i)) {
  //   // console.log("Android device");
  //   iPhone = true;
  // }

  // // Check for iOS (iPhone, iPad, iPod)
  // if (userAgent.match(/iPhone|iPad|iPod/i)) {
  //   // console.log("Apple device");
  //   iPhone = true;
  // }

  // console.log(userAgent,'satya','1');


  const videoUrl =
    "https://cdn.shopify.com/videos/c/o/v/da5fed448d224a6dae7dd3e29401a84d.mp4";
  const thumbnailUrl =
    "https://cdn.shopify.com/s/files/1/0084/6957/7794/files/Rectangle_2711.png?v=1700677120";

    const scrollToBottom = () => {
      (window as any).scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    };


    const storeLink = isIOS
    ? 'https://apps.apple.com/app/aqualens-contact-lenses/id1671107844'
    : isAndroid
    ? 'https://play.google.com/store/apps/details?id=com.lenskart.aqualens'
    : 'https://aqualens.in/account/';

    const openStore = () => {
      if (storeLink !== 'https://aqualens.in/account/') {
        (window as any).open(storeLink, '_blank');
      }else{
        (window as any).open(storeLink, '_blank');
      }
    };

    const redirectToHomePage = () => {
      // Redirect to home page
      window.location.href = 'https://aqualens.in/';
    };
  

  if (status === "CANCELLED" || lenskart_order_id == null) {
    return (
      <div className="">
        <div className="">
          <div style={{ marginTop: "0px" }}>
            <div style={{ margin: "auto", width: "400px" }}>
              <Lottie
                animationData={payment_error}
                loop
                autoplay
                height={200}
                width={200}
              />
            </div>

            <div className="orderFailedText">
              <h2>Order Failed.</h2>
              <p>
                Order processing failed.If any amount deducted will be refunded.
              </p>
            </div>
            <div className="retryOrderWrapper">
              <button className="retryOrder" onClick={() => retryOrder()}>
                Retry
                {/* <Link to="/">Retry</Link> */}
              </button>
            </div>
          </div>
        </div>

        
       
      </div>
    );
  } else {
    return (
      <div className="thankyouWrapper">
        <div className="w-fit m-auto orderIcon" style={{ width: "100%", position:'relative' }}>

            <button 
                  className="cta-button"
                  style={{
                    position: 'absolute',
                    top: '20px',
                    right: '0px',
                    padding: '10px',
                    backgroundColor: '#469DA1',
                    color: '#fff',
                    borderTopLeftRadius:'50px',
                    borderBottomLeftRadius:'50px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    zIndex: '9'
                  }}
                  onClick={scrollToBottom}
                >
                  Wear & Care
            </button>


        <div className="w-fit m-auto orderIcon" style={{ width: "263px", position:'relative' }}>
          <Lottie
            animationData={order_confirm}
            loop
            autoplay
            height={200}
            width={200}
          />
          </div>
        </div>

        <div className="orderConfirmText">
          <p className="text-center confirmText">
          Thank you for your purchase!
          </p>
          <p className="text-center confirmSubText">
            Order Id : <span>#{lenskart_order_id}</span>
          </p>
        </div>
       
        <div className="order_details">
              <div className="order_details_wrapper">
                <div className="details_content">
                  <div className="order_details_img">
                    <img style={{ height:"60px", width:"60px" }} src={itemImage} alt="" />
                  </div>
                  <div>
                    <p className="order_heading">Order Placed</p>
                    <p className="order_subHeading">{createdAt}</p>
                  </div>
                </div>
                <div className="order_details_content">
                  <a href="https://aqualens.in/pages/my-orders">Order Details</a>
                </div>
              </div>

              <div className="order_products">{firstItem} {itemsNumber > 0 ? `+ ${itemsNumber}` : ''}</div>

              <svg
                height="4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="1" width="100%" height="4" rx="2" fill="#E8E8E8" />
                <rect width="72" height="4" rx="2" fill="#469DA1" />
              </svg>

              <div className="est_date_wrapper">
                <span className="order_confirmed_text">Order Confirmed</span>
                <span className="order_confirmed_subText">Delivery by {deliveryDate}</span>
              </div>
        </div>


        { cashback && cashback > 0 ? 
        <>
            <div className="aquacashCredited ">
              <div>
                <img src={giftBox} alt="" />
              </div>
              <div className="cust_name">{customerName}, {cashback} Aquacash credited, just for you!</div>
            </div>
            </>
            : ''

        }


      

        {/* <div className="homeCTA">
            <div
            className="backToHOme"
            >
            <a href="https://aqualens.in/">Back To Home</a>
            </div>

            <a href="https://aqualens.in/pages/my-orders">
                <button className="orderDetails ripple orderDetailsButton">
                    <span>Show order Details</span>
                    </button>
            </a>
        </div> */}

        {/* <div className="downloadAppContainer">
          <div className="downloadAppWrapper">
            <img src={appBanner} alt="img" />
            <img src={dicountBanner} alt="img" />


            <a
              className="playStore"
              href="https://apps.apple.com/app/aqualens-contact-lenses/id1671107844"
            >
              <img src={playStore} alt="" />
            </a>

            <a
              className="appleStore"
              href="https://play.google.com/store/apps/details?id=com.lenskart.aqualens"
            >
              <img src={iosStore} alt="" />
            </a>
          </div>
        </div> */}


        
        <Slider />
        <HoverRating shopify_order_id={shopify_order_id} />
        <Aquatribe />
        <VideoSection videoUrl={videoUrl} thumbnailUrl={thumbnailUrl} />
        <GuideCTA />
        <FollowUsOn />

        <div className="orderDetailsCTA">
          {/* <a style={{ width: "50%" }} href="https://aqualens.in/"> */}
            <button className="ripple orderDetailsButton" onClick={redirectToHomePage} style={{ width: "50%" }}>
              <span>View Homepage</span>
            </button>
          {/* </a> */}


          {/* <a style={{ width: "50%" }} href="https://aqualens.page.link/home">  */}
            <button onClick={openStore} className="orderDetails ripple" style={{ width: "50%" }}>
              <span>Track Order on App</span>
            </button>
          {/* </a> */}



        {/* { /iPad|iPhone|iPod/i.test(userAgent) ? 
          <a
            style={{ width: "50%" }}
            href="https://apps.apple.com/app/aqualens-contact-lenses/id1671107844"
          >
            <button className="orderDetails ripple">
              <span>Track Order on App</span>
            </button>
          </a>
          : 
          <a
          style={{ width: "50%" }}
          href="https://play.google.com/store/apps/details?id=com.lenskart.aqualens"
        >
          
          <button className="orderDetails ripple">
            <span>Track Order on App</span>
          </button>
        </a>
        } */}

        </div>
      </div>
    );
  }
};

export default Thankyou;
